import React from "react";
import Navbar from "./Navbar/Navbar";
import Top_Header from "./Top_Header/Top_Header";

export default function Header() {
  return (
    <div>
      <Top_Header />
      <Navbar />
    </div>
  );
}
